import { Image, StyleSheet, Text, View } from "react-native";
import React from "react";
const GrayScale = ({ grayImg }: { grayImg: any }) => {
  return (
    <View style={{ width: "100%", height: "50%", opacity: 0.6 }}>
      <View style={styles.container}>
        <Image width={356} height={200} source={{ uri: grayImg }} />
        <View style={styles.overlay} />
      </View>
    </View>
  );
};
export default GrayScale;
const styles = StyleSheet.create({
  container: { position: "relative" },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#000000",
  },
});